import React from 'react'

import { LntTag } from '@app/components/base'

import { TAG_TYPE } from '@app/constants/tag'

import { INTERNAL_TASKS_STATUS, INTERNAL_TASKS_STATUS_TITLE } from '@app/constants/internalTasksStatus'

import { ObjectValuesType } from '@app/types'

import type { LntTagType } from '@app/components/base/Tag/types'

type StatusType = ObjectValuesType<typeof INTERNAL_TASKS_STATUS> | null

const matchStatusToTagType = (status?: ObjectValuesType<typeof INTERNAL_TASKS_STATUS> | null): LntTagType => {
  switch (status) {
    case INTERNAL_TASKS_STATUS.APPROVAL:
    case INTERNAL_TASKS_STATUS.DKC_APPROVAL:
    case INTERNAL_TASKS_STATUS.SOAC_APPROVAL:
    case INTERNAL_TASKS_STATUS.UNDER_REVISION:
      return TAG_TYPE.primary

    case INTERNAL_TASKS_STATUS.APPROVED:
    case INTERNAL_TASKS_STATUS.APPROVED_WITH_CHANGES:
    case INTERNAL_TASKS_STATUS.PARTIALLY_APPROVED:
      return TAG_TYPE.success

    case INTERNAL_TASKS_STATUS.OVERDUE:
    case INTERNAL_TASKS_STATUS.REJECTED:
    case INTERNAL_TASKS_STATUS.CANCELLED_BY_INITIATOR:
      return TAG_TYPE.danger

    default:
      return TAG_TYPE.default
  }
}

const statusToTagText = (status?: StatusType): string => {
  if (!status) return 'Не определен'

  return INTERNAL_TASKS_STATUS_TITLE[status]
}

export const InternalTaskStatusTagRender: React.FC<{ status?: StatusType }> = ({ status }) => {
  const type = matchStatusToTagType(status)
  const statusText = statusToTagText(status)

  return <LntTag type={ type }>{ statusText }</LntTag>
}
